module.exports = __webpack_public_path__ + "static/media/rscreen-en.d5cd08c4.png";